module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.2391ce45.mp3";